var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-item story"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-7 col-xl-5"},[_c('div',{staticClass:"storytelling"},[_c('div',{},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.cardText.text)}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }